module.exports = __webpack_public_path__ + "static/GloberSemiBold-9cb53f0d2ec4e9ed07e818cd07f8ec48.woff2";